export * from "./designer-or-store-logo";
